import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const root =
  ({
    positionX,
    positionY,
  }: {
    positionX: "right" | "center";
    positionY: "center" | "bottom";
  }) =>
  (theme: ExactTheme) => css`
    position: fixed;
    z-index: ${theme.zIndices.modals};
    inset: 0;

    display: flex;
    overflow-y: auto;
    padding: 24px;
    box-sizing: border-box;

    min-height: 100dvh;
    background-color: rgba(0, 0, 0, 0.1);

    > * {
      margin-top: auto;
      margin-bottom: ${positionY === "center" ? "auto" : "0"};
      margin-left: auto;
      margin-right: ${positionX === "center" ? "auto" : "0"};
    }
  `;

export const container = (theme: ExactTheme) => css`
  position: relative;
  background: white;
  border-radius: ${theme.borderRadiusV2.primary};
  box-shadow: ${theme.shadowV2.primary};
`;

export const outsideCloseButton = (theme: ExactTheme) => css`
  z-index: ${theme.zIndices.modalCloseButton};
  position: absolute;
  cursor: pointer;
  right: -16px;
  top: -16px;

  .CloseButton-background {
    box-shadow: ${theme.shadowV2.tertiary};
    background: white;
  }
  :hover {
    .CloseButton-background {
      //box-shadow: none;
    }
  }
`;

export const insideCloseButton = (theme: ExactTheme) => css`
  right: 9px;
  top: 9px;
  z-index: ${theme.zIndices.modalCloseButton};
  position: absolute;
  cursor: pointer;
`;

export const header = css`
  padding: 10px 40px;
  text-align: center;
`;

export const body = css`
  padding: 20px;
`;

export const footer = css`
  padding: 25px 20px;
  display: flex;
`;

export const buttonsContainer = ({ count }: { count: number }) => css`
  grid-template-columns: repeat(${count}, 1fr);
  display: inline-grid;
  gap: 10px;
  margin: auto;
`;
